import { useState } from 'react'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { ThemeProvider } from '@opallabs/hooks'
import { WithTheme } from '@opallabs/lapidary'
import { AddCaptionsModal } from '..'
import {
  AddCaptionsModalProps,
  CaptionAssetReference,
  CaptionSubmission,
} from '../types'

type QueryableAddCaptionsModalProps = Readonly<
  Omit<AddCaptionsModalProps, 'isVisible'> & WithTheme
>

export const QueryableAddCaptionsModal: React.FC<
  QueryableAddCaptionsModalProps
> = ({ initialCaptions, onCloseModal, onSubmit, theme = 'light' }) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    setIsVisible(false)
    onCloseModal()
  }

  const handleSubmit = (captions: ReadonlyArray<CaptionSubmission>) => {
    onSubmit(captions)
    handleClose()
  }

  return (
    <DefaultQueryClientProvider>
      <ThemeProvider theme={theme}>
        <AddCaptionsModal
          isVisible={isVisible}
          initialCaptions={
            initialCaptions as ReadonlyArray<CaptionAssetReference>
          }
          onCloseModal={handleClose}
          onSubmit={handleSubmit}
        />
      </ThemeProvider>
    </DefaultQueryClientProvider>
  )
}
